// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { ReactElement } from 'react';
import { Box, useTheme } from '@mui/system';
import { Dialog, DialogActions, Button, Typography } from '@mui/material/';
import ErrorIcon from '@mui/icons-material/Error';
import stylesDef from './styles';

interface WarningDialogProps {
  showDialog: boolean;
  onResolve: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onProceed?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  titleText: string;
  resolveButtonText: string;
  proceedButtonText?: string;
  children: ReactElement;
}

export const WarningDialog = ({ showDialog, onResolve, onProceed, titleText, resolveButtonText, proceedButtonText, children }: WarningDialogProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <Dialog open={showDialog} sx={styles.dialog}>
      <Box sx={styles.dialogBox}>
        <Box sx={styles.dialogTitle}>
          <ErrorIcon sx={styles.warningIcon} />
          <Typography variant="h3" sx={styles.titleText}>{titleText}</Typography>
        </Box>
        {children}
        <DialogActions sx={styles.dialogActions}>
          <Button onClick={onResolve} sx={styles.resolveButton}>{resolveButtonText}</Button>
          {proceedButtonText && <Button onClick={onProceed} sx={styles.closeButton}>{proceedButtonText}</Button>}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default WarningDialog;
